import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  setModalPrincipal,
  setModalSignup,
} from "../../shared/slice/ModalLogin/ModalLoginSlice";
import { setRootLoading } from "../../shared/slice/rootSlice";
import { setPromos } from "../../shared/slice/promos/PromosSlice";
import { setmodalCheckout } from "../../shared/slice/auth/AuthSlice";
import {
  setMenu,
  setMode,
  setModeSelectedId,
  setOpenModal,
  setRestaurantSelected,
  setEditOrder,
} from "../../shared/slice/restaurant/RestaurantSlice";
import { setScroll } from "../../shared/slice/scroll/ScrollSlice";
import Logo from "../../assets/images/eatorder-logo-white.png";
import LogoEatorder from "../../assets/images/eatorder-logo.png";
import { store } from "../../shared";
import NotificationSecond from "../../components/Notification/notificationSecond";
import SideNavBarSecond from "../../components/Navbar/SideNavBarSecond";
import ModalLogin from "../Modals/ModalLogin";
import ModalSignup from "../Modals/ModalSignup";
import ModalPrincipal from "../Modals/ModalPrincipal";
import ModalEmailSend from "../Modals/ModalEmailSend";
import { useNavigate } from "react-router-dom";
import TermsPopup from "../TermsOfService/TermsPopup";

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px; /* Adjust spacing between logos */
`;
const CardBadge = styled.h6`
  min-width: 20px;
  min-height: 20px;
  background-color: #000;
  border-radius: 50%;
  text-align: center;
  margin-left: -10px;
  color: #fff;
`;
const LogoImage03 = styled.img`
  height: 18px;
  margin-left: 2px;
`;
const LogoImageFooter = styled.img`
  height: 18px;
  @media (min-width: 768px) {
    height: 25px;
  }
`;
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 8px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: white; /* Ensure it has a background color */
  z-index: 1000; /* Ensure it appears above other elements */
`;
const StyledAnchor = styled.button`
  padding: 8px 20px;
  background-color: #eb1700;
  color: white;
  text-decoration: none;
  border-radius: 25px;
  text-align: center;
  margin-right: 5px;
  @media (max-width: 336px) {
    padding: 4px 10px;
  }
`;
const StyledAnchor2 = styled.button`
  padding: 8px 20px;
  color: #363332;
  text-align: center;
  background-color: #e6dddc;
  border-radius: 25px;
  margin-right: 10px;
  @media (max-width: 336) {
    padding: 4px 10px;
  }
`;

const AnimatedLink = styled.a`
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease, border-bottom 0.3s ease;
  border-bottom: 1px solid transparent;

  &:hover {
    color: #ddd;
    border-bottom: 1px solid #ddd;
  }
  @media (max-width: 576px) {
    font-size: 0.9rem; /* Smaller font size on smaller screens */
  }
`;

const FooterSection = styled.section`
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-bottom: 1rem; /* Add some space below the links on small screens */

  @media (min-width: 768px) {
    /* Keep links in a row on larger screens */
    margin-bottom: 0; /* Remove bottom margin on larger screens */
  }
`;

const SocialIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-direction: column;
  text-align: center;

  span {
    @media (max-width: 576px) {
      display: none; /* Hide the text on very small screens */
    }
  }
  @media (max-width: 576px) {
    margin-bottom: 2rem !important;
  }
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

const IconsContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

const DescriptionText = styled.p`
  font-size: 0.9rem; /* Slightly smaller font size for the description */
  text-align: center; /* Center the description text */
  @media (max-width: 576px) {
    font-size: 0.8rem; /* Even smaller on very small screens */
  }
`;
const PrivacyPolicyWrapper = styled.div`
  max-width: 720px;
  margin: 0 auto;
  padding: 4rem 1.5rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  color: #000;
  line-height: 1.75;
  font-size: 1rem;

  h1,
  h2 {
    font-weight: 600;
    margin: 2rem 0 1rem;
  }

  h1 {
    font-size: 2rem;
    text-align: center;
    margin-bottom: 3rem;
  }

  h2 {
    font-size: 1.25rem;
  }

  p {
    margin-bottom: 1.25rem;
  }

  ul {
    padding-left: 1.25rem;
    margin-bottom: 1.5rem;
  }

  li {
    margin-bottom: 0.5rem;
  }

  .content-section {
    margin-bottom: 3rem;
  }

  span,
  strong {
    font-weight: 500;
  }

  @media (max-width: 600px) {
    padding: 2rem 1rem;
    h1 {
      font-size: 1.75rem;
    }
    h2 {
      font-size: 1.125rem;
    }
  }
`;

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const loggedInGuest = useSelector(
    (state) => state.authentification.loggedInGuest
  );
  const loggedInUser = useSelector(
    (state) => state.authentification.loggedInUser
  );
  const isLoggedIn = useSelector((state) => state.authentification.isLoggedIn);
  const dispatch = useDispatch();
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  useEffect(() => {
    store.dispatch(setRootLoading(false));
    store.dispatch(setPromos({ promos: [] }));
    store.dispatch(setmodalCheckout({ modalCheckout: false }));
    dispatch(setMode({}));
    store.dispatch(setScroll({ scroll: 0 }));
    store.dispatch(setModeSelectedId({ modeSelectedId: "" }));
    store.dispatch(setRestaurantSelected({}));
    store.dispatch(setMenu({}));
  }, []);
  console.log("User termsAccepted:", loggedInUser?.termsAccepted);
  console.log("localStorage:", localStorage.getItem("termsAccepted"));
  const navigate = useNavigate();
  store.dispatch(
    setOpenModal({
      product: undefined,
      open: false,
    })
  );
  store.dispatch(
    setEditOrder({
      open: false,
      objectOptions: [],
      checkedIndices: [],
      checkedOptions: [],
      counter: {},
      orderQuantity: 0,
      note: undefined,
      size: "",
    })
  );
  const SignIn = () => {
    store.dispatch(setModalPrincipal({ modalPrincipal: true }));
  };
  const SignUp = () => {
    store.dispatch(setModalSignup({ modalSignup: true }));
  };
  useEffect(() => {
    const accepted = localStorage.getItem("termsAccepted") === "true";
    if (accepted) {
      setShowTermsPopup(false);
    } else {
      setShowTermsPopup(true);
    }
  }, []);
  return (
    <>
      <Container>
        <LogoContainer>
          <LogoImage03
            src={LogoEatorder}
            alt="Eatorder Logo"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
        </LogoContainer>
        {!isLoggedIn && (
          <div>
            <StyledAnchor onClick={() => SignIn()}>{t("Sign In")}</StyledAnchor>
            <StyledAnchor2 onClick={() => SignUp()}>
              {t("Sign Up")}
            </StyledAnchor2>
          </div>
        )}
        {isLoggedIn && (
          <div>
            <NotificationSecond
              style={{ backgroundColor: "green!important" }}
            />
            {unreadCount > 0 && (
              <CardBadge>
                <div>{unreadCount}</div>
              </CardBadge>
            )}

            <SideNavBarSecond />
          </div>
        )}
      </Container>
      {isLoggedIn && loggedInUser && !loggedInUser.termsAccepted && (
        <TermsPopup />
      )}
      <div>
        <ModalLogin />
        <ModalSignup />
        <ModalPrincipal />
        <ModalEmailSend />
      </div>
      <PrivacyPolicyWrapper>
        <h1>{t("privacy.title")}</h1>
        <p>{t("privacy.intro")}</p>

        <div className="content-section">
          <h2>{t("privacy.section1.title")}</h2>
          <ul>
            {t("privacy.section1.items", { returnObjects: true }).map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>
        </div>

        <div className="content-section">
          <h2>{t("privacy.section2.title")}</h2>
          <p>{t("privacy.section2.intro")}</p>
          <ul>
            {t("privacy.section2.items", { returnObjects: true }).map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>
          <p
            dangerouslySetInnerHTML={{ __html: t("privacy.section2.legal") }}
          />
        </div>

        <div className="content-section">
          <h2>{t("privacy.section3.title")}</h2>
          <p>{t("privacy.section3.intro")}</p>
          <ul>
            {t("privacy.section3.items", { returnObjects: true }).map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>
        </div>

        <div className="content-section">
          <h2>{t("privacy.section4.title")}</h2>
          <p>{t("privacy.section4.intro")}</p>
          <ul>
            {t("privacy.section4.items", { returnObjects: true }).map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>
          <p>{t("privacy.section4.contact")}</p>
        </div>

        <div className="content-section">
          <h2>{t("privacy.section5.title")}</h2>
          <p>{t("privacy.section5.content")}</p>
        </div>

        <div className="content-section">
          <h2>{t("privacy.section6.title")}</h2>
          <p>{t("privacy.section6.content")}</p>
        </div>

        <div className="content-section">
          <h2>{t("privacy.section7.title")}</h2>
          <p>{t("privacy.section7.content")}</p>
        </div>

        <div className="content-section">
          <h2>{t("privacy.section8.title")}</h2>
          <p>{t("privacy.section8.content")}</p>
        </div>
      </PrivacyPolicyWrapper>
      <MDBFooter
        style={{ fontSize: "1rem" }}
        bgColor="dark"
        className="text-center text-lg-start text-light"
      >
        <FooterSection className="d-flex flex-column flex-lg-row justify-content-between align-items-center p-4 border-bottom border-light">
          <SocialIcons>
            <span>{t("Get connected with us on social networks")}</span>
            <IconsContainer>
              <a
                href="#"
                className="me-3 text-reset text-light"
                aria-label="Facebook"
              >
                <MDBIcon fab icon="facebook-f" />
              </a>
              <a
                href="#"
                className="me-3 text-reset text-light"
                aria-label="Twitter"
              >
                <MDBIcon fab icon="twitter" />
              </a>
              <a
                href="#"
                className="me-3 text-reset text-light"
                aria-label="Google"
              >
                <MDBIcon fab icon="google" />
              </a>
              <a
                href="#"
                className="text-reset text-light"
                aria-label="Instagram"
              >
                <MDBIcon fab icon="instagram" />
              </a>
            </IconsContainer>
          </SocialIcons>
          <LinkContainer>
            <AnimatedLink href="/privacy-policy">
              {t("Privacy Policy")}
            </AnimatedLink>
            <AnimatedLink href="/terms-of-service">
              {t("Terms of Service")}
            </AnimatedLink>
          </LinkContainer>
        </FooterSection>
        <section className="">
          <MDBContainer className="text-center text-md-start mt-5">
            <MDBRow className="mt-3">
              <MDBCol
                md="3"
                lg="4"
                xl="3"
                className="mx-auto mb-4"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <h6 className="text-uppercase fw-bold mb-4">
                  <LogoImageFooter src={Logo} alt="Eatorder Logo" />
                </h6>
                <DescriptionText>
                  {t(
                    "Craving something delicious? Order your favorite meals from our platform and enjoy fast, easy, and reliable food delivery. Discover a wide variety of cuisines, exclusive deals, and hassle-free ordering. Satisfaction guaranteed with every bite."
                  )}
                </DescriptionText>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </section>
      </MDBFooter>
    </>
  );
};

export default PrivacyPolicy;
